import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BlockUIService {
    public blocked = false;

    constructor() {}

    start(){
        // Usar setTimeout para evitar ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => {
            this.blocked = true;
        }, 0);
    }

    stop(){ 
        // Usar setTimeout para evitar ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => {
            this.blocked = false;
        }, 0);
    } 
}

